import axiosInstance from '@/services/axiosInstance';
import { pickBody } from '@/api/helpers';

export type CalendarListItem = {
  id: string;
  organizationId: string;
  name: string;
  description: string | null;
  color: string | null;
  timeZone: string | null;
  isPrimary: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  createdById: string;
  updatedById: string | null;
};

type ListResponse = { success?: boolean; data: CalendarListItem[] };

const list = (): Promise<CalendarListItem[]> =>
  axiosInstance.get<unknown>('/api/v1/calendars').then((res) => {
    const raw = pickBody<ListResponse | CalendarListItem[]>(res.data);
    if (Array.isArray(raw)) return raw;
    return raw?.data ?? [];
  });

export type CreateCalendarInput = {
  name: string;
  description?: string | null;
  color?: string | null;
  timeZone?: string | null;
  isPrimary?: boolean;
};

const create = (input: CreateCalendarInput): Promise<CalendarListItem> =>
  axiosInstance.post<unknown>('/api/v1/calendars', input).then((res) => {
    const raw = pickBody<{ success?: boolean; data: CalendarListItem }>(res.data);
    return raw.data;
  });

const calendarsApi = {
  list,
  create,
};

export { calendarsApi };
